import React from 'react';
import { Card } from "react-bootstrap";
import face_gyorgy_karolyi from "../../assets/img/face_gyorgy_karolyi.png";
import ShowMoreText from "react-show-more-text";
import proj_dissip_billiards from "../../assets/img/proj_dissip_billiards.png";

const Gyorgy_Karolyi_dissip_billiards = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_dissip_billiards} />
        <br />
        <Card.Body>
          <Card.Text className="d-flex justify-content-start card-text">
            {" "}

            <div>
            <img
              className="img2"
              src={face_gyorgy_karolyi}
              alt="Fractal Basin Boundaries in Dissipative Billiards"
            />{" "}
            <p className="text7">György Károlyi</p>
            <br />
            <p className="text8">
              Professor{" "}
            </p>
            </div>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            <p className="text8">Institute of Nuclear Techniques, BME </p>
            </div>
            <div>
            Dissipative triangular and rectangular billiards have multiple stable states (attractors), and the boundary between 
            their basins of attraction are said to be fractal. Recent results show, however, that the fractality in some purely 
            dissipative physical systems may depend on how one looks at the phase space. During this project, via numerical 
            simulations, we explore the fractality of basin boundaries in dissipative triangular and/or rectangular billiards.
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Gyorgy_Karolyi_dissip_billiards;